import { QueryClient } from '@tanstack/react-query';

const defaultQueryConfig = { staleTime: 60000 };

export const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig }
});

export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    SECURITY_SCHEMES: 'security-schemes',
    SECURITY_SCHEME: 'security-scheme',
    SECURITY_SCHEMES_METADATA: 'security-schemes-metadata',
    PERMISSION_OBJECTS: 'permission-objects'
};

export const MUTATION_KEYS = {
    SECURITY_SCHEME: 'security-scheme'
};
